import {
  type ArenaPackRewardDto,
  type BoxReward,
} from '../types/shop/marketBoxes';

interface BalancePayload {
  tgem: number;
  cash: number;
  dice: number;
  usdt: number;
}

interface StoragePayload {
  item: string;
  value: number;
  costPerUnit?: number;
}

export function transformArenaOfferReward(rewardObj: ArenaPackRewardDto): {
  balancePayload: BalancePayload;
  storagePayload: StoragePayload[];
} {
  // 1. Створюємо масив винагород для обробки
  const rewardsToProcess: (ArenaPackRewardDto | BoxReward)[] = [];

  if (rewardObj.arenaOffer) {
    rewardsToProcess.push(rewardObj.arenaOffer);
  } else if (rewardObj.elit_1 || rewardObj.elit_2) {
    // Додаємо обидва, якщо вони існують
    if (rewardObj.elit_1) {
      rewardsToProcess.push(rewardObj.elit_1);
    }

    if (rewardObj.elit_2) {
      rewardsToProcess.push(rewardObj.elit_2);
    }
  } else {
    // Базовий випадок: обробляємо сам 'rewardObj'
    rewardsToProcess.push(rewardObj);
  }

  // 2. Ініціалізуємо "акумулятори"
  const balancePayload: BalancePayload = { tgem: 0, cash: 0, dice: 0, usdt: 0 };
  const storageItems: StoragePayload[] = [];

  // 3. Обходимо *всі* винагороди в масиві та підсумовуємо їх
  for (const reward of rewardsToProcess) {
    // 3.1. Підсумовуємо баланс
    if ('tgem' in reward) {
      balancePayload.tgem += reward.tgem || 0;
    }

    if ('cash' in reward) {
      balancePayload.cash += reward.cash || 0;
    }

    if ('dice' in reward) {
      balancePayload.dice += reward.dice || 0;
    }

    if ('usdt' in reward) {
      balancePayload.usdt += reward.usdt || 0;
    }

    // 3.2. Збираємо всі предмети (ваш код, але в циклі)
    reward.resources?.forEach((resource) => {
      const [item, details] = Object.entries(resource)[0];
      let value: number;

      if (typeof details === 'number') {
        value = details;
      } else {
        value = details.amount;
      }
      storageItems.push({
        item,
        value,
      });
    });

    reward.materials?.forEach((material) => {
      const [item, details] = Object.entries(material)[0];
      let value: number;

      if (typeof details === 'number') {
        value = details;
      } else {
        value = details.amount;
      }
      storageItems.push({
        item,
        value,
      });
    });

    if ('products' in reward && reward.products) {
      reward.products?.forEach((product) => {
        const [item, details] = Object.entries(product)[0];
        let value: number;

        if (typeof details === 'number') {
          value = details;
        } else {
          value = details.amount;
        }
        storageItems.push({
          item,
          value,
        });
      });
    }
  }

  // 4. Групуємо однакові item
  const groupedStorageItems: StoragePayload[] = Object.values(
    storageItems.reduce(
      (acc, curr) => {
        if (acc[curr.item]) {
          acc[curr.item].value += curr.value;
        } else {
          acc[curr.item] = { ...curr };
        }

        return acc;
      },
      {} as Record<string, StoragePayload>,
    ),
  );

  return {
    balancePayload,
    storagePayload: groupedStorageItems,
  };
}
